<template>
    <div class="email-template-preview">
        <table class="table table-responsive table-striped table-hover">
            <thead>
            <tr>
                <th>
                    Template Name
                </th>
                <th></th>
            </tr>
            </thead>

            <tbody>
            <tr v-bind:key="template" v-for="template in emailTemplates" class="pointer" @click="openModal( template )">
                <td>
                    {{template}}
                </td>
                <td class="text-right">View</td>
            </tr>
            </tbody>
        </table>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               :width="720"
               @opened="setHeight"
               height="90%">
            <div class="dashboard-block">
                <fieldset>
                    <legend>{{template}}</legend>

                    <div class="background-white" :class="{loading: loading}">
                        <iframe
                            frameborder="0"
                            width="690"
                            :height="height"
                            :src="templateUrl">
                        </iframe>
                    </div>
                </fieldset>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },

            emailTemplates: {
                required: true,
                type: Array
            },
        },

        data(){
            return {
                loading: false,
                template: null,
                height: 500,
            };
        },

        computed: {
            templateUrl(){
                return '/emailTemplates/' + this.template;
            },
        },

        methods: {
            setHeight(){
                var element = this.$el.getElementsByClassName( 'v--modal' )[ 0 ];

                if( element ){
                    this.height = element.offsetHeight - 82;
                }
            },

            openModal( template ){
                this.template = template;

                this.$modal.show( this.modalId );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            }
        }
    }
</script>
